/* eslint-disable no-undef */
import React, { Component } from 'react';

import { FlowChart } from './flowchart';
import { Control } from './control';
import { positionEle, makeAConnection } from '../../util';

import 'styles/home.scss';


const styleObject = {
  color: '#87cefa',
};
// eslint-disable-next-line no-undef

export class Home extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-state
    this.state = {
      flowchartData: [],
      totalEle: 0,
      manualConnections: [],
      removedData: [],
      connectorSettings: {},
    };
    this.control = React.createRef();
  }
  resetState = () => {
    let { flowchartData, manualConnections } = this.state;
    flowchartData = flowchartData.concat(manualConnections);
    flowchartData.forEach(({ lineRef }) => {
      if (lineRef) {
        try {
          lineRef.remove();
        } catch {
          console.log('need to handle this case');
        }
      }
    });
    this.setState({
      flowchartData: [],
      totalEle: 0,
      manualConnections: [],
      removedData: [],
      connectorSettings: {},
    })
  }

  addShape = ({ text, shapeName }) => {
    const {
      flowchartData: flowchartDataOld, currentActiveCircle, index, totalEle,
      connectorSettings
    } = this.state;
    const { position } = flowchartDataOld[index] || {};
    const currentActiveEle = flowchartDataOld[index];
    let start; let end; let activeCircleIndex; let endCircleIndex; const coming = []; const going = []; let
      id;

    if (position === 'right') {
      endCircleIndex = 1;
      activeCircleIndex = 5;
      if (shapeName === 'DiamondSquare') {
        endCircleIndex = 2;
        activeCircleIndex = 6;
      }
    } else if (position === 'left') {
      endCircleIndex = 5;
      activeCircleIndex = 1;
      if (shapeName === 'DiamondSquare') {
        endCircleIndex = 6;
        activeCircleIndex = 2;
      }
    } else if (position === 'top') {
      endCircleIndex = 3;
      activeCircleIndex = 7;
      if (shapeName === 'DiamondSquare') {
        endCircleIndex = 4;
        activeCircleIndex = 0;
      }
    } else if (position === 'topRight') {
      endCircleIndex = 2;
      activeCircleIndex = 6;
      if (shapeName === 'DiamondSquare') {
        endCircleIndex = 3;
        activeCircleIndex = 7;
      }
    } else if (position === 'topLeft') {
      endCircleIndex = 4;
      activeCircleIndex = 0;
      if (shapeName === 'DiamondSquare') {
        endCircleIndex = 5;
        activeCircleIndex = 1;
      }
    } else if (position === 'bottomRight') {
      endCircleIndex = 0;
      activeCircleIndex = 4;
      if (shapeName === 'DiamondSquare') {
        endCircleIndex = 1;
        activeCircleIndex = 5;
      }
    } else if (position === 'bottomLeft') {
      endCircleIndex = 6;
      activeCircleIndex = 2;
      if (shapeName === 'DiamondSquare') {
        endCircleIndex = 7;
        activeCircleIndex = 3;
      }
    } else {
      endCircleIndex = 7;
      activeCircleIndex = 3;
      if (shapeName === 'DiamondSquare') {
        endCircleIndex = 0;
        activeCircleIndex = 4;
      }
    }
    id = `${shapeName}flowchart${totalEle}`;
    start = `${id}circle${endCircleIndex}`;
    end = `${id}circle${activeCircleIndex}`;
    if (currentActiveEle) {
      const obj = {
        from: `${currentActiveEle.shapeName}flowchart${index}circle${currentActiveEle.activeCircleIndex}`,
        to: start,
        fromArray: [currentActiveEle.shapeName, 'flowchart', index, 'circle', currentActiveEle.activeCircleIndex],
        toArray: [shapeName, 'flowchart', totalEle, 'circle', endCircleIndex],
      };
      coming.push(obj);
      flowchartDataOld[index].going.push(obj);
    }
    flowchartDataOld.push(
      {
        shapeName,
        text,
        start,
        activeCircleIndex,
        end,
        endCircleIndex,
        position,
        coming,
        going,
        id,
      },
    );
    this.setState({
      flowchartData: flowchartDataOld,
      currentActiveCircle: end,
      index: flowchartDataOld.length - 1,
      totalEle: totalEle + 1,
    }, () => {
      if ((flowchartDataOld.length >= 2) && jQuery) {
        positionEle(flowchartDataOld, index);
        this.lineRef = makeAConnection(currentActiveCircle, start, position,'',connectorSettings);
      } else {
        document.getElementById(flowchartDataOld[0].id).style.top = '30px';
        document.getElementById(flowchartDataOld[0].id).style.left = '198px';
      }
      this.setState((state) => {
        const { flowchartData } = state;
        const { length } = flowchartData;
        const lastShape = flowchartData[length - 1];
        if (lastShape) {
          const lastEle = document.getElementById(lastShape.id);
          document.getElementById(`${lastShape.id}Text`).focus();
          const { top } = lastEle.style;
          const { left } = lastEle.style;
          flowchartData[length - 1].style = {
            top, left,
          };
          flowchartData[length - 1].lineRef = this.lineRef;
          if (length >= 2 && !flowchartData[0].lineRef) {
            flowchartData[0].lineRef = this.lineRef;
          }
          return {
            flowchartData,
          };
        }
      });
    });
  }

  removeShape = (index) => {
    const {
      flowchartData: flowchartDataOld, manualConnections, removedData, connectorSettings,
    } = this.state;
    // removeConnections(flowchartDataOld);
    if (index > -1) {
      removedData.push(flowchartDataOld[index]);
      flowchartDataOld.splice(index, 1);
    }
    const { length } = flowchartDataOld;
    const lastElement = flowchartDataOld[length - 1] || {};
    const currentActiveCircle = `${lastElement.shapeName}flowchart${length - 1}${3}`;
    this.setState({ flowchartData: flowchartDataOld, currentActiveCircle, removedData }, () => {
      manualConnections.forEach(({ from, to }) => {
        const fromTo = `#${from}, #${to}`;
        makeAConnection(fromTo, connectorSettings);
      });
    });
  }

  connectHandler = (connectTo, position) => {
    const { connectFrom, manualConnections, connectFromPos,connectorSettings } = this.state;
    if (!connectFrom) {
      this.setState({ connectFrom: connectTo, connectFromPos: position });
    } else if (connectFrom === connectTo) {
      this.setState({ connectFrom: '', connectFromPos: '' });
    } else {
      const lineRef = makeAConnection(connectFrom, connectTo, connectFromPos, position,connectorSettings);
      manualConnections.push({ from: connectFrom, to: connectTo, lineRef });
      this.setState({ connectFrom: '', manualConnections });
    }
  }

  circleOnClick = (index, activeCircleIndex, position) => {
    const { flowchartData: flowchartDataOld } = this.state;
    const start = `${flowchartDataOld[index].id}circle${activeCircleIndex}`;
    flowchartDataOld[index].activeCircleIndex = activeCircleIndex;
    flowchartDataOld[index].start = start;
    flowchartDataOld[index].position = position;
    this.setState({ flowchartData: flowchartDataOld, currentActiveCircle: start, index });
  }

  getConnectorSettings = (connectorSettings) => {
    if (connectorSettings) {
      this.setState({ connectorSettings });
    }
  }

  connectionUpdater = () => {
    let { flowchartData, manualConnections } = this.state;
    flowchartData = flowchartData.concat(manualConnections);
    flowchartData.forEach(({ lineRef }) => {
      if (lineRef) {
        try {
          lineRef.position();
        } catch {
          console.log('need to handle this case');
        }
      }
    });
  }

  render() {
    const {
      flowchartData, connectFrom, connectorSettings, currentActiveCircle,
    } = this.state;
    return (
      <div className="home">
        <FlowChart
          flowchartData={flowchartData}
          styleObject={styleObject}
          removeShape={this.removeShape}
          circleOnClick={this.circleOnClick}
          connectFrom={connectFrom}
          connectHandler={this.connectHandler}
          controlRef={this.control}
          connectorSettings={connectorSettings}
          currentActiveCircle={currentActiveCircle}
          resetState={this.resetState}
          connectionUpdater={this.connectionUpdater}
        />
        <Control
          addShape={this.addShape}
          styleObject={styleObject}
          ref={this.control}
          getConnectorSettings={this.getConnectorSettings}
          connectorSettings={connectorSettings}
        />
      </div>
    );
  }
}
